export enum BankAccountTypeEnum {
  CHECKING = 'checking',
  SAVINGS = 'savings',
  CORPORATE_CHECKING = 'corporate_checking',
  CORPORATE_SAVINGS = 'corporate_savings',
}
